import { message } from 'antd';
import React, { createContext, useEffect, useMemo, useReducer } from 'react';
import { useLocation, useParams } from "react-router-dom";
import axios from '../../../axios';
let initialValue = {
    all_products: []
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                products_data: action.payload,
            }
        }
        case 'UPDATE_STATUS': {
            let newData = state.products_data.all_products.map((pro) =>
                action.payload.data.id === pro.id ? action.payload.data : pro
            );
            let newState = {
                all_products: newData
            }
            return {
                ...state,
                products_data: newState,
            }
        }
        case 'REMOVE_FEATURED': {
            let newData = state.products_data.all_products.filter((pro) =>
                action.payload.product_id !== pro.id
            );
            let newState = {
                all_products: newData
            }
            return {
                ...state,
                products_data: newState,
            }
        }
        default: {
            return state
        }
    }
}

const AllProductsContext = createContext({
    products_data: initialValue,
    getAllProductsData: () => { },
    getAllProductsFilterList: () => { },
    changeProductStatus: () => { },
    make_featured: () => { },
    remove_featured: () => { },
    changeProductDelivery: () => { },
})

export const AllProductsProvider = ({ settings, children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const getAllProductsData = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken');
        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }
            const res = await axios.post(`/api/products/all_products`, data, options);
            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const getAllProductsFilterList = async (data) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            return await axios.post(`/api/products/all_searched_products`, data, options);
        } catch (e) {
            return null;
        }
    }


    const changeProductDelivery = async (product_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_delivery/${product_id}/${status}`, options);


            // refetch the products data
            if (typeof window !== undefined) {
                if(window?.location){
                    const path = window?.location?.pathname;
                    const pathData = localStorage.getItem(path);
                    if (pathData) {
                        const params = JSON.parse(pathData);
                        getAllProductsData(params);
                    }
                }
                
            }


            if (res.status === 200) {
                dispatch({
                    type: 'UPDATE_STATUS',
                    payload: res.data
                })
            } else {
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    const changeProductStatus = async (product_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken');


        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_status/${product_id}/${status}`, options);

            // refetch the products data
            if (typeof window !== 'undefined') {
                const path = window?.location?.pathname;
                const pathData = localStorage.getItem(path);
                if (pathData) {
                    const params = JSON.parse(pathData);
                    getAllProductsData(params);
                }
            }


            if (res.status === 200) {
                dispatch({
                    type: 'UPDATE_STATUS',
                    payload: res.data
                })
            } else {
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            message.error(e?.message);
        }
    }

    const make_featured = async (product_id) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/make_featured/${product_id}`, options);

            if (res.status === 200) {
                dispatch({
                    type: 'MAKE_FEATURED',
                    payload: res.data
                })
            } else {
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    const remove_featured = async (product_id) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/remove_featured/${product_id}`, options);

            if (res.status === 200) {
                dispatch({
                    type: 'REMOVE_FEATURED',
                    payload: res.data
                })
            } else {
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getAllProductsData({ page: 1, pageSize: 10 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const params = useParams();
    const location = useLocation();

    function queryParamToJson(queryParam) {
        // Remove the leading "?" if it's present
        if (queryParam.startsWith('?')) {
          queryParam = queryParam.slice(1);
        }
      
        const params = new URLSearchParams(queryParam);
        const result = {};
      
        for (const [key, value] of params.entries()) {
          // You can parse the values if needed, e.g., parseInt
          result[key] = value;
        }
      
        return result;
      }

    
    useMemo(() => {
        const jsonResult = queryParamToJson(location?.search);
        if(jsonResult?.sub_category_id){
            getAllProductsData({ page: 1, pageSize: 10, sub_category_id:jsonResult?.sub_category_id });
        }
    }, [params, location]);

    return (
        <AllProductsContext.Provider
            value={{
                products_data: state.products_data,
                getAllProductsData,
                getAllProductsFilterList,
                changeProductStatus,
                make_featured,
                remove_featured,
                changeProductDelivery,
            }}
        >
            {children}
        </AllProductsContext.Provider>
    )
}

export default AllProductsContext
